import { __theme } from './antd/antd';
import __PaginationComp from './components/pagination/pagination.index';

export const COLORS = {
    primary: '#00a684',
    black1: '#1b1d28',
    gray1: '#818288',
    white: '#ffffff',
    black: '#000000',
    black2: '#1d1c21',
    gray2: '#8e8e90',
    gray3: '#d1d1d1',
    bgLight: '#f3f3f3',
    bgDark: '#101010',
    black3: '#0d1a12',
    lightGreen: '#b7e7dd',
    red: '#ed3e32',
};

export { __theme as AntdTheme };
export { __PaginationComp as PaginationComp };
